import React from 'react';
import { Button } from 'reactstrap';
import { ExportStatus } from './types';

interface ExportFailureViewProps {
  exportStatus: ExportStatus;
  onRetry: () => void;
  onClose: () => void;
}

const ExportFailureView: React.FC<ExportFailureViewProps> = ({
  exportStatus,
  onRetry,
  onClose
}) => {
  if (!exportStatus || exportStatus.status !== 'failed') return null;

  return (
    <div className="text-center">
      <div className="mb-4">
        <i className="icon-error text-danger" style={{ fontSize: '48px' }} />
      </div>
      
      <h5 className="text-danger mb-3">Export Failed</h5>
      
      <div className="alert alert-danger text-left mb-4 flex flex-column">
        {exportStatus.export_id && (
          <div className="mb-2">
            <strong>Export ID:</strong> {exportStatus.export_id}
          </div>
        )}
        <div className="mb-0">
          <strong>Error Details:</strong> {exportStatus.message}
        </div>
      </div>

      <div className="mb-4 text-left">
        <p className="mb-3">
          Please share the error information with the Customer Support team. Include the Export ID and error details above when contacting support.
        </p>
        <h6 className="text-muted mb-3">Common Troubleshooting Tips</h6>
        <ul className="text-muted mb-0" style={{ paddingLeft: '1.2rem' }}>
          <li className="mb-2">Check your GruntWorx dashboard to see if files were partially uploaded</li>
          <li className="mb-2">Verify your GruntWorx integration settings</li>
          <li className="mb-2">Try exporting fewer files at once</li>
          <li className="mb-0">Ensure all files have proper client assignments</li>
        </ul>
      </div>

      <div className="row">
        <div className="col-12 justify-content-end formbtn">
          <div className="btn-wrap btn--leftspace">
            <Button
              className="btn btn-outline-light"
              onClick={onClose}
            >
              Close
            </Button>
            <Button
              className="btn btn-primary"
              onClick={onRetry}
            >
              Try Again
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExportFailureView; 